import { useTranslation } from 'react-i18next';
import { EmptyState, LoadingBlock } from '../../components/ui.tsx';
import JobChatSettings from '../../components/settings/job-chat-settings.tsx';
import { useJobChatSettingsAccess } from '../../components/settings/job-chat-access.ts';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/**
 * Settings › Texting & calls › Job chat settings: the company's preferences
 * for visit chats. The chats themselves are `/chats`; this is only how they
 * behave.
 */
export default function JobChatSettingsPage() {
  const { t } = useTranslation();
  const access = useJobChatSettingsAccess();
  return (
    <SettingsLeafPage
      title={t('settings.messagingPages.tiles.jobChat.title')}
      back={{ to: '/settings/messaging', label: t('settings.messagingPages.backToMessaging') }}
    >
      {access.loading ? (
        <LoadingBlock label={t('settings.loadingSettings')} />
      ) : access.available ? (
        <JobChatSettings capabilityChecked />
      ) : (
        <EmptyState title={t('settings.messagingPages.jobChatUnavailable')} />
      )}
    </SettingsLeafPage>
  );
}
